<template>
  <div class="relation">
    <div class="contentWidth">
      <div class="relationConcant contentWidth">
        <div class="relationConcantTB" @mouseover='ImgMouse(1)' style="width:200%;">
          <div class="relationConcantLR" style="height:100%;">
            <img src="../../assets/img/relation/relationNew1.jpg" alt="">
            <div class="relationIcon12Zhe" :style="'opacity:'+(ImgHover==1?'1':'0')">
              <svg v-if="ImgHover==1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 180.83 46.361" style="enable-background:new 0 0 180.83 46.361;" xml:space="preserve">
              <path style="fill:#fff;" stroke='#fff' d="M81.46-0.033V22.75h-3.854V-0.033H81.46z"/>
              <rect style="fill:#fff;" stroke='#fff' x="140.819" y="0.04" width="3.874" height="3.858"/>
              <path style="fill:#fff;" stroke='#fff' d="M86.021,5.831h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
              c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
              c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
              c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
              c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
              c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.831z"/>
              <path style="fill:#fff;" stroke='#fff' d="M129.62,0.934l11.078,19.933l-3.375,1.876L126.245,2.809L129.62,0.934z"/>
              <path style="fill:#fff;" stroke='#fff' d="M144.681,5.815V22.75h-3.861V5.815H144.681z"/>
              <path style="fill:#fff;" stroke='#fff' d="M125.667,19.06h-4.246c-2.959,0-5.026-1.861-5.026-4.527c0-2.79,2.27-5.06,5.059-5.06h0.934
              l-1.778,5.498h3.947l3.299-9.17h-6.401c-4.815,0-8.73,3.917-8.73,8.731c0,4.674,3.739,8.198,8.697,8.198h6.443L125.667,19.06z"
              />
              <path style="fill:#fff;" stroke='#fff' d="M17.856,5.692c-0.403-0.83-0.905-1.603-1.491-2.296c-0.59-0.698-1.274-1.303-2.035-1.8
              c-0.76-0.496-1.607-0.885-2.517-1.157c-0.912-0.272-1.899-0.41-2.934-0.41H0.008v22.686H8.88c1.501,0,2.898-0.296,4.151-0.879
              c1.25-0.582,2.34-1.398,3.24-2.427c0.895-1.022,1.598-2.237,2.092-3.612c0.491-1.369,0.74-2.871,0.74-4.464
              c0-1.015-0.107-2.011-0.319-2.959C18.572,7.424,18.26,6.522,17.856,5.692z M3.493,3.222H7.93c1.103,0,2.139,0.164,3.079,0.488
              c0.922,0.318,1.734,0.81,2.413,1.462c0.677,0.652,1.217,1.497,1.605,2.514c0.392,1.031,0.591,2.274,0.591,3.695
              c0,1.297-0.196,2.467-0.583,3.477c-0.383,1.001-0.921,1.855-1.599,2.54c-0.676,0.684-1.491,1.214-2.422,1.575
              c-0.94,0.365-1.977,0.55-3.083,0.55H3.493V3.222z"/>
              <path style="fill:#fff;" stroke='#fff' d="M32.297,5.843c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
              c0,4.719,3.537,7.89,8.802,7.89h7.511V5.846l-3.229,0L32.297,5.843z M31.996,9.289l2.267,0.134v9.79h-3.915
              c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
              C31.524,9.271,31.757,9.277,31.996,9.289z"/>
              <path style="fill:#fff;" stroke='#fff' d="M17.796,40.986c-0.127,0.253-0.254,0.498-0.377,0.731c-0.096,0.183-0.019,0.405,0.167,0.495
              c0.366,0.178,0.733,0.372,1.099,0.574c0.435-0.468,0.81-1,1.105-1.607c0.043-0.089-0.024-0.193-0.123-0.193H17.796z
              M17.753,36.992c-0.699,0.815-1.573,1.583-2.389,2.052c-0.145-0.329-0.451-0.814-0.713-1.095
              c0.946-0.408,1.981-1.254,2.68-2.162h-2.462v-1.159h2.884v-2.835h1.238v2.835h2.87v1.159H19.37
              c0.714,0.454,1.777,1.175,2.083,1.394l-0.729,1.033c-0.349-0.36-1.092-1.002-1.733-1.519v1.942h-1.238V36.992z M20.025,45.105
              c-0.32-0.267-0.728-0.564-1.194-0.845c-1.005,0.845-2.199,1.424-3.525,1.801c-0.116-0.312-0.378-0.83-0.612-1.095
              c1.122-0.283,2.156-0.721,3.045-1.363c-0.521-0.303-1.074-0.581-1.605-0.825c-0.278-0.128-0.383-0.465-0.23-0.729
              c0.191-0.328,0.383-0.695,0.583-1.061h-1.34v-1.19h1.893c0.146-0.344,0.227-0.472,0.355-0.779l1.218,0.058
              c-0.088,0.235-0.19,0.469-0.291,0.721h2.473c0.416,0,0.698,0.418,0.548,0.806c-0.411,1.062-1.032,2.066-1.638,2.78
              c0.422,0.267,0.83,0.516,1.136,0.752L20.025,45.105z M16.18,34.595c-0.117-0.547-0.481-1.394-0.859-2.02l0.99-0.439
              c0.379,0.596,0.772,1.41,0.903,1.974L16.18,34.595z M21.584,32.56c-0.437,0.704-0.903,1.456-1.297,1.942l-0.874-0.423
              c0.349-0.564,0.786-1.426,1.034-2.035L21.584,32.56z M26.958,36.099c-0.306,2.271-0.757,4.166-1.5,5.732
              c0.714,1.331,1.631,2.381,2.782,3.07c-0.306,0.251-0.685,0.783-0.889,1.129c-1.063-0.69-1.923-1.692-2.622-2.882
              c-0.83,1.269-1.908,2.287-3.336,3.085c-0.116-0.297-0.495-0.908-0.713-1.19c1.515-0.768,2.607-1.817,3.394-3.226
              c-0.481-1.127-0.874-2.381-1.165-3.758c-0.262,0.657-0.568,1.237-0.889,1.738c-0.203-0.251-0.713-0.705-1.005-0.909
              c1.136-1.644,1.791-4.244,2.127-6.985l1.238,0.187c-0.117,0.909-0.277,1.802-0.466,2.647h3.686
              c0.168,0,0.304,0.136,0.304,0.304v1.058H26.958z M23.681,36.099c0.247,1.504,0.611,2.914,1.092,4.198
              c0.422-1.222,0.728-2.6,0.932-4.198H23.681z"/>

              <path style="fill:#fff;" stroke='#fff' d="M157.635,34.803c-0.407-0.751-1.311-1.91-2.039-2.741l-1.034,0.721
              c0.728,0.877,1.587,2.083,1.966,2.85L157.635,34.803z"/>
              <path style="fill:#fff;" stroke='#fff' d="M162.325,44.295h1.398v-2.57h3.091v-1.377h-3.091v-1.785h2.747v-1.348h-2.747v-1.769h-1.398
              v1.769h-1.923c-0.14,0-0.23-0.148-0.166-0.273l1.142-2.201h5.433v-1.254l-4.903,0.008l0.6-1.115l-1.262-0.55l-0.86,1.636
              l-2.271,0.022v1.254h1.719l-1.201,2.23c-0.153,0.283-0.171,0.62-0.05,0.919h0c0.166,0.408,0.562,0.675,1.003,0.674
              c0.19-0.001,0.4-0.001,0.611-0.001h2.127v1.785h-4.218v1.377h4.218V44.295z"/>
              <path style="fill:#fff;" stroke='#fff' d="M158.13,43.934c-0.436-0.297-0.742-0.564-1.005-0.736v-6.077h-3.088v1.347h1.792v4.588
              c-0.627,0.282-1.355,0.972-2.068,1.88l0.99,1.426c0.597-1.019,1.223-2.052,1.66-2.052c0.32,0,0.83,0.548,1.442,0.955
              c1.077,0.689,2.287,0.861,4.18,0.861c1.486,0,4.05-0.093,5.069-0.172c0.029-0.439,0.262-1.205,0.422-1.629
              c-1.456,0.219-3.758,0.361-5.447,0.361C160.403,44.686,159.092,44.577,158.13,43.934z"/>

              <path style="fill:#fff;" stroke='#fff' d="M111.437,46.258v-0.002h6.556v0.002h1.416v-4.978c0-0.587-0.476-1.064-1.064-1.064h-8.279
              v6.042H111.437z M111.435,41.943h0.001v-0.541h6.244c0.172,0,0.312,0.14,0.312,0.312v0.938h-0.001v1.122h0.001v1.281h-6.556
              v-0.732h-0.001V41.943z"/>
              <path style="fill:#fff;" stroke='#fff' d="M111.585,38.198c0.715,0.528,1.684,1.281,2.116,1.666l0.969-0.977
              c-0.402-0.305-2.041-1.346-2.652-1.667l0.044-0.144h2.652V35.89h-2.444c0.015-0.16,0.015-0.32,0.015-0.48v-0.834h2.056V33.39
              h-3.859c0.119-0.352,0.238-0.689,0.343-1.057l-1.237-0.273c-0.313,1.186-0.894,2.355-1.639,3.156
              c0.283,0.129,0.79,0.481,1.058,0.673h-1.013v1.186h2.697c-0.342,0.898-1.117,1.826-2.846,2.548
              c0.313,0.24,0.701,0.704,0.879,0.993C110.185,39.912,111.064,39.062,111.585,38.198z M109.067,35.89
              c0.313-0.368,0.611-0.801,0.864-1.314h1.043v0.817c0,0.16,0,0.321-0.015,0.497H109.067z"/>
              <path style="fill:#fff;" stroke='#fff' d="M115.281,33.374v5.719h3.319c1.138,0,2.061-0.923,2.061-2.061v-3.659H115.281z M119.289,36.842
              c0,0.518-0.42,0.938-0.938,0.938h-1.774v-3.092h2.712V36.842z"/>
              <rect style="fill:#fff;" stroke='#fff' x="111.967" y="42.581" width="5.512" height="1.145"/>

              <path style="fill:#fff;" stroke='#fff' d="M61.082,37.905l0.146,1.065c1.34-0.142,3.117-0.314,4.923-0.516v0.641h1.209v-0.768
              l0.786-0.093v-0.062c0.175,0.235,0.335,0.485,0.437,0.704c0.976-0.376,1.908-0.923,2.709-1.629
              c0.816,0.548,1.529,1.097,2.025,1.551l0.859-0.987c-0.495-0.439-1.194-0.94-1.981-1.456c0.541-0.615,1.137-1.488,1.573-2.395
              c0.227-0.472-0.115-1.019-0.638-1.019l0,0h-4.736v1.158h3.544c0.152,0,0.248,0.164,0.173,0.296
              c-0.269,0.47-0.601,0.914-0.963,1.302c-0.743-0.439-1.515-0.861-2.185-1.206l-0.801,0.847
              c0.656,0.36,1.369,0.766,2.068,1.205c-0.64,0.501-1.354,0.909-2.083,1.206l0.014-0.516l-0.801,0.078v-3.822h0.873v-1.065
              h-6.89v1.065h1.078v4.308C61.942,37.826,61.476,37.873,61.082,37.905z M63.629,33.635h0.003v-0.148h2.52v0.752h-0.001v0.861
              h0.001v0.768h-0.001v0.862h0.001v0.704c-0.874,0.094-1.719,0.172-2.52,0.251v-0.563h-0.003V33.635z"/>
              <path style="fill:#fff;" stroke='#fff' d="M62.117,43.214c1.573-0.329,3.569-0.925,4.996-1.519l-1.15-0.658
              c-1.253,0.469-3.161,0.908-4.836,1.175C61.432,42.431,61.898,42.964,62.117,43.214z"/>
              <path style="fill:#fff;" stroke='#fff' d="M70.492,42.885c1.049-0.454,2.287-1.08,3.278-1.706l-1.092-0.768
              c-0.801,0.564-2.097,1.299-3.147,1.785c-0.422-0.344-0.771-0.721-1.063-1.127v-0.721c1.631-0.189,3.205-0.423,4.443-0.69
              l-0.961-0.923c-2.433,0.485-6.657,0.83-9.949,0.83c0.234,0.297,0.554,0.923,0.714,1.237c1.34-0.062,2.87-0.172,4.413-0.314
              v2.82l-0.859-0.486c-1.296,0.721-3.394,1.426-5.258,1.817c0.321,0.25,0.83,0.783,1.092,1.08
              c1.588-0.454,3.569-1.19,5.025-1.973v2.552h1.34V42.76c1.369,1.379,3.278,2.334,5.375,2.82
              c0.175-0.376,0.539-0.909,0.801-1.191C73.099,44.138,71.672,43.605,70.492,42.885z"/>

              <rect style="fill:#fff;" stroke='#fff' x="63.941" y="34.274" width="1.876" height="0.829"/>
              <rect style="fill:#fff;" stroke='#fff' x="63.941" y="35.718" width="1.876" height="0.829"/>

              <path style="fill:#fff;" stroke='#fff' d="M174.477,12.463c0.992,1.685,2.009,3.398,3.051,5.137c1.041,1.74,2.058,3.452,3.051,5.137h-4.368
              l-4.433-7.567c-0.251,0.25-0.486,0.484-0.704,0.701c-0.218,0.218-0.415,0.418-0.589,0.603c-0.196,0.207-0.387,0.402-0.573,0.587
              v5.675h-3.86V0.004h3.86v12.215l6.2-6.083h4.711L174.477,12.463z"/>
              <path style="fill:#fff;" stroke='#fff' d="M108.228,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
              c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
              V8.92h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372V8.92h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
              c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C107.224,22.64,107.715,22.744,108.228,22.744
              C108.227,22.744,108.228,22.744,108.228,22.744z"/>
              <!-- <rect style="fill:#fff;" stroke='#fff' x="109.334" y="19.6" style="fill:#fff;" width="2.299" height="0.56"/> -->
              <path style="fill:#fff;" stroke='#fff' d="M46.211,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
              c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
              V8.921h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372v3.157h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
              c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C45.207,22.64,45.698,22.744,46.211,22.744
              C46.211,22.744,46.211,22.744,46.211,22.744z"/>
              <path style="fill:#fff;" stroke='#fff' d="M61.526,5.911c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
              c0,4.719,3.537,7.89,8.802,7.89h7.511V5.914l-3.229,0L61.526,5.911z M61.225,9.357l2.267,0.134v9.79h-3.915
              c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
              C60.753,9.339,60.986,9.345,61.225,9.357z"/>
              <path style="fill:#fff;" stroke='#fff' d="M148.439,5.845h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
              c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
              c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
              c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
              c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
              c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.845z"/>

              </svg>
            </div>
          </div>
        </div>
        <div class="relationConcantTB" style="overflow:hidden;">
          <div class="relationConcantLR" @mouseover='ImgMouse(2)' style="margin-bottom:4px;">
            <img src="../../assets/img/relation/relationNew2.jpg" alt="">
            <div class="relationIcon12Zhe" :style="'opacity:'+(ImgHover==2?'1':'0')">
              <svg v-if="ImgHover==2" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 180.83 46.361" style="enable-background:new 0 0 180.83 46.361;" xml:space="preserve">
              <path style="fill:#fff;" stroke='#fff' d="M81.46-0.033V22.75h-3.854V-0.033H81.46z"/>
              <rect style="fill:#fff;" stroke='#fff' x="140.819" y="0.04" width="3.874" height="3.858"/>
              <path style="fill:#fff;" stroke='#fff' d="M86.021,5.831h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
              c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
              c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
              c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
              c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
              c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.831z"/>
              <path style="fill:#fff;" stroke='#fff' d="M129.62,0.934l11.078,19.933l-3.375,1.876L126.245,2.809L129.62,0.934z"/>
              <path style="fill:#fff;" stroke='#fff' d="M144.681,5.815V22.75h-3.861V5.815H144.681z"/>
              <path style="fill:#fff;" stroke='#fff' d="M125.667,19.06h-4.246c-2.959,0-5.026-1.861-5.026-4.527c0-2.79,2.27-5.06,5.059-5.06h0.934
              l-1.778,5.498h3.947l3.299-9.17h-6.401c-4.815,0-8.73,3.917-8.73,8.731c0,4.674,3.739,8.198,8.697,8.198h6.443L125.667,19.06z"
              />
              <path style="fill:#fff;" stroke='#fff' d="M17.856,5.692c-0.403-0.83-0.905-1.603-1.491-2.296c-0.59-0.698-1.274-1.303-2.035-1.8
              c-0.76-0.496-1.607-0.885-2.517-1.157c-0.912-0.272-1.899-0.41-2.934-0.41H0.008v22.686H8.88c1.501,0,2.898-0.296,4.151-0.879
              c1.25-0.582,2.34-1.398,3.24-2.427c0.895-1.022,1.598-2.237,2.092-3.612c0.491-1.369,0.74-2.871,0.74-4.464
              c0-1.015-0.107-2.011-0.319-2.959C18.572,7.424,18.26,6.522,17.856,5.692z M3.493,3.222H7.93c1.103,0,2.139,0.164,3.079,0.488
              c0.922,0.318,1.734,0.81,2.413,1.462c0.677,0.652,1.217,1.497,1.605,2.514c0.392,1.031,0.591,2.274,0.591,3.695
              c0,1.297-0.196,2.467-0.583,3.477c-0.383,1.001-0.921,1.855-1.599,2.54c-0.676,0.684-1.491,1.214-2.422,1.575
              c-0.94,0.365-1.977,0.55-3.083,0.55H3.493V3.222z"/>
              <path style="fill:#fff;" stroke='#fff' d="M32.297,5.843c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
              c0,4.719,3.537,7.89,8.802,7.89h7.511V5.846l-3.229,0L32.297,5.843z M31.996,9.289l2.267,0.134v9.79h-3.915
              c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
              C31.524,9.271,31.757,9.277,31.996,9.289z"/>
              <path style="fill:#fff;" stroke='#fff' d="M17.796,40.986c-0.127,0.253-0.254,0.498-0.377,0.731c-0.096,0.183-0.019,0.405,0.167,0.495
              c0.366,0.178,0.733,0.372,1.099,0.574c0.435-0.468,0.81-1,1.105-1.607c0.043-0.089-0.024-0.193-0.123-0.193H17.796z
              M17.753,36.992c-0.699,0.815-1.573,1.583-2.389,2.052c-0.145-0.329-0.451-0.814-0.713-1.095
              c0.946-0.408,1.981-1.254,2.68-2.162h-2.462v-1.159h2.884v-2.835h1.238v2.835h2.87v1.159H19.37
              c0.714,0.454,1.777,1.175,2.083,1.394l-0.729,1.033c-0.349-0.36-1.092-1.002-1.733-1.519v1.942h-1.238V36.992z M20.025,45.105
              c-0.32-0.267-0.728-0.564-1.194-0.845c-1.005,0.845-2.199,1.424-3.525,1.801c-0.116-0.312-0.378-0.83-0.612-1.095
              c1.122-0.283,2.156-0.721,3.045-1.363c-0.521-0.303-1.074-0.581-1.605-0.825c-0.278-0.128-0.383-0.465-0.23-0.729
              c0.191-0.328,0.383-0.695,0.583-1.061h-1.34v-1.19h1.893c0.146-0.344,0.227-0.472,0.355-0.779l1.218,0.058
              c-0.088,0.235-0.19,0.469-0.291,0.721h2.473c0.416,0,0.698,0.418,0.548,0.806c-0.411,1.062-1.032,2.066-1.638,2.78
              c0.422,0.267,0.83,0.516,1.136,0.752L20.025,45.105z M16.18,34.595c-0.117-0.547-0.481-1.394-0.859-2.02l0.99-0.439
              c0.379,0.596,0.772,1.41,0.903,1.974L16.18,34.595z M21.584,32.56c-0.437,0.704-0.903,1.456-1.297,1.942l-0.874-0.423
              c0.349-0.564,0.786-1.426,1.034-2.035L21.584,32.56z M26.958,36.099c-0.306,2.271-0.757,4.166-1.5,5.732
              c0.714,1.331,1.631,2.381,2.782,3.07c-0.306,0.251-0.685,0.783-0.889,1.129c-1.063-0.69-1.923-1.692-2.622-2.882
              c-0.83,1.269-1.908,2.287-3.336,3.085c-0.116-0.297-0.495-0.908-0.713-1.19c1.515-0.768,2.607-1.817,3.394-3.226
              c-0.481-1.127-0.874-2.381-1.165-3.758c-0.262,0.657-0.568,1.237-0.889,1.738c-0.203-0.251-0.713-0.705-1.005-0.909
              c1.136-1.644,1.791-4.244,2.127-6.985l1.238,0.187c-0.117,0.909-0.277,1.802-0.466,2.647h3.686
              c0.168,0,0.304,0.136,0.304,0.304v1.058H26.958z M23.681,36.099c0.247,1.504,0.611,2.914,1.092,4.198
              c0.422-1.222,0.728-2.6,0.932-4.198H23.681z"/>

              <path style="fill:#fff;" stroke='#fff' d="M157.635,34.803c-0.407-0.751-1.311-1.91-2.039-2.741l-1.034,0.721
              c0.728,0.877,1.587,2.083,1.966,2.85L157.635,34.803z"/>
              <path style="fill:#fff;" stroke='#fff' d="M162.325,44.295h1.398v-2.57h3.091v-1.377h-3.091v-1.785h2.747v-1.348h-2.747v-1.769h-1.398
              v1.769h-1.923c-0.14,0-0.23-0.148-0.166-0.273l1.142-2.201h5.433v-1.254l-4.903,0.008l0.6-1.115l-1.262-0.55l-0.86,1.636
              l-2.271,0.022v1.254h1.719l-1.201,2.23c-0.153,0.283-0.171,0.62-0.05,0.919h0c0.166,0.408,0.562,0.675,1.003,0.674
              c0.19-0.001,0.4-0.001,0.611-0.001h2.127v1.785h-4.218v1.377h4.218V44.295z"/>
              <path style="fill:#fff;" stroke='#fff' d="M158.13,43.934c-0.436-0.297-0.742-0.564-1.005-0.736v-6.077h-3.088v1.347h1.792v4.588
              c-0.627,0.282-1.355,0.972-2.068,1.88l0.99,1.426c0.597-1.019,1.223-2.052,1.66-2.052c0.32,0,0.83,0.548,1.442,0.955
              c1.077,0.689,2.287,0.861,4.18,0.861c1.486,0,4.05-0.093,5.069-0.172c0.029-0.439,0.262-1.205,0.422-1.629
              c-1.456,0.219-3.758,0.361-5.447,0.361C160.403,44.686,159.092,44.577,158.13,43.934z"/>

              <path style="fill:#fff;" stroke='#fff' d="M111.437,46.258v-0.002h6.556v0.002h1.416v-4.978c0-0.587-0.476-1.064-1.064-1.064h-8.279
              v6.042H111.437z M111.435,41.943h0.001v-0.541h6.244c0.172,0,0.312,0.14,0.312,0.312v0.938h-0.001v1.122h0.001v1.281h-6.556
              v-0.732h-0.001V41.943z"/>
              <path style="fill:#fff;" stroke='#fff' d="M111.585,38.198c0.715,0.528,1.684,1.281,2.116,1.666l0.969-0.977
              c-0.402-0.305-2.041-1.346-2.652-1.667l0.044-0.144h2.652V35.89h-2.444c0.015-0.16,0.015-0.32,0.015-0.48v-0.834h2.056V33.39
              h-3.859c0.119-0.352,0.238-0.689,0.343-1.057l-1.237-0.273c-0.313,1.186-0.894,2.355-1.639,3.156
              c0.283,0.129,0.79,0.481,1.058,0.673h-1.013v1.186h2.697c-0.342,0.898-1.117,1.826-2.846,2.548
              c0.313,0.24,0.701,0.704,0.879,0.993C110.185,39.912,111.064,39.062,111.585,38.198z M109.067,35.89
              c0.313-0.368,0.611-0.801,0.864-1.314h1.043v0.817c0,0.16,0,0.321-0.015,0.497H109.067z"/>
              <path style="fill:#fff;" stroke='#fff' d="M115.281,33.374v5.719h3.319c1.138,0,2.061-0.923,2.061-2.061v-3.659H115.281z M119.289,36.842
              c0,0.518-0.42,0.938-0.938,0.938h-1.774v-3.092h2.712V36.842z"/>
              <rect style="fill:#fff;" stroke='#fff' x="111.967" y="42.581" width="5.512" height="1.145"/>

              <path style="fill:#fff;" stroke='#fff' d="M61.082,37.905l0.146,1.065c1.34-0.142,3.117-0.314,4.923-0.516v0.641h1.209v-0.768
              l0.786-0.093v-0.062c0.175,0.235,0.335,0.485,0.437,0.704c0.976-0.376,1.908-0.923,2.709-1.629
              c0.816,0.548,1.529,1.097,2.025,1.551l0.859-0.987c-0.495-0.439-1.194-0.94-1.981-1.456c0.541-0.615,1.137-1.488,1.573-2.395
              c0.227-0.472-0.115-1.019-0.638-1.019l0,0h-4.736v1.158h3.544c0.152,0,0.248,0.164,0.173,0.296
              c-0.269,0.47-0.601,0.914-0.963,1.302c-0.743-0.439-1.515-0.861-2.185-1.206l-0.801,0.847
              c0.656,0.36,1.369,0.766,2.068,1.205c-0.64,0.501-1.354,0.909-2.083,1.206l0.014-0.516l-0.801,0.078v-3.822h0.873v-1.065
              h-6.89v1.065h1.078v4.308C61.942,37.826,61.476,37.873,61.082,37.905z M63.629,33.635h0.003v-0.148h2.52v0.752h-0.001v0.861
              h0.001v0.768h-0.001v0.862h0.001v0.704c-0.874,0.094-1.719,0.172-2.52,0.251v-0.563h-0.003V33.635z"/>
              <path style="fill:#fff;" stroke='#fff' d="M62.117,43.214c1.573-0.329,3.569-0.925,4.996-1.519l-1.15-0.658
              c-1.253,0.469-3.161,0.908-4.836,1.175C61.432,42.431,61.898,42.964,62.117,43.214z"/>
              <path style="fill:#fff;" stroke='#fff' d="M70.492,42.885c1.049-0.454,2.287-1.08,3.278-1.706l-1.092-0.768
              c-0.801,0.564-2.097,1.299-3.147,1.785c-0.422-0.344-0.771-0.721-1.063-1.127v-0.721c1.631-0.189,3.205-0.423,4.443-0.69
              l-0.961-0.923c-2.433,0.485-6.657,0.83-9.949,0.83c0.234,0.297,0.554,0.923,0.714,1.237c1.34-0.062,2.87-0.172,4.413-0.314
              v2.82l-0.859-0.486c-1.296,0.721-3.394,1.426-5.258,1.817c0.321,0.25,0.83,0.783,1.092,1.08
              c1.588-0.454,3.569-1.19,5.025-1.973v2.552h1.34V42.76c1.369,1.379,3.278,2.334,5.375,2.82
              c0.175-0.376,0.539-0.909,0.801-1.191C73.099,44.138,71.672,43.605,70.492,42.885z"/>

              <rect style="fill:#fff;" stroke='#fff' x="63.941" y="34.274" width="1.876" height="0.829"/>
              <rect style="fill:#fff;" stroke='#fff' x="63.941" y="35.718" width="1.876" height="0.829"/>

              <path style="fill:#fff;" stroke='#fff' d="M174.477,12.463c0.992,1.685,2.009,3.398,3.051,5.137c1.041,1.74,2.058,3.452,3.051,5.137h-4.368
              l-4.433-7.567c-0.251,0.25-0.486,0.484-0.704,0.701c-0.218,0.218-0.415,0.418-0.589,0.603c-0.196,0.207-0.387,0.402-0.573,0.587
              v5.675h-3.86V0.004h3.86v12.215l6.2-6.083h4.711L174.477,12.463z"/>
              <path style="fill:#fff;" stroke='#fff' d="M108.228,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
              c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
              V8.92h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372V8.92h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
              c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C107.224,22.64,107.715,22.744,108.228,22.744
              C108.227,22.744,108.228,22.744,108.228,22.744z"/>
              <!-- <rect style="fill:#fff;" stroke='#fff' x="109.334" y="19.6" style="fill:#fff;" width="2.299" height="0.56"/> -->
              <path style="fill:#fff;" stroke='#fff' d="M46.211,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
              c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
              V8.921h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372v3.157h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
              c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C45.207,22.64,45.698,22.744,46.211,22.744
              C46.211,22.744,46.211,22.744,46.211,22.744z"/>
              <path style="fill:#fff;" stroke='#fff' d="M61.526,5.911c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
              c0,4.719,3.537,7.89,8.802,7.89h7.511V5.914l-3.229,0L61.526,5.911z M61.225,9.357l2.267,0.134v9.79h-3.915
              c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
              C60.753,9.339,60.986,9.345,61.225,9.357z"/>
              <path style="fill:#fff;" stroke='#fff' d="M148.439,5.845h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
              c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
              c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
              c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
              c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
              c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.845z"/>

              </svg>
            </div>
          </div>
          <div class="relationConcantLR" @mouseover='ImgMouse(3)'>
            <img src="../../assets/img/relation/relationNew3.jpg" alt="">
            <div class="relationIcon12Zhe" :style="'opacity:'+(ImgHover==3?'1':'0')">
              <svg v-if="ImgHover==3" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 180.83 46.361" style="enable-background:new 0 0 180.83 46.361;" xml:space="preserve">
              <path style="fill:#fff;" stroke='#fff' d="M81.46-0.033V22.75h-3.854V-0.033H81.46z"/>
              <rect style="fill:#fff;" stroke='#fff' x="140.819" y="0.04" width="3.874" height="3.858"/>
              <path style="fill:#fff;" stroke='#fff' d="M86.021,5.831h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
              c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
              c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
              c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
              c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
              c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.831z"/>
              <path style="fill:#fff;" stroke='#fff' d="M129.62,0.934l11.078,19.933l-3.375,1.876L126.245,2.809L129.62,0.934z"/>
              <path style="fill:#fff;" stroke='#fff' d="M144.681,5.815V22.75h-3.861V5.815H144.681z"/>
              <path style="fill:#fff;" stroke='#fff' d="M125.667,19.06h-4.246c-2.959,0-5.026-1.861-5.026-4.527c0-2.79,2.27-5.06,5.059-5.06h0.934
              l-1.778,5.498h3.947l3.299-9.17h-6.401c-4.815,0-8.73,3.917-8.73,8.731c0,4.674,3.739,8.198,8.697,8.198h6.443L125.667,19.06z"
              />
              <path style="fill:#fff;" stroke='#fff' d="M17.856,5.692c-0.403-0.83-0.905-1.603-1.491-2.296c-0.59-0.698-1.274-1.303-2.035-1.8
              c-0.76-0.496-1.607-0.885-2.517-1.157c-0.912-0.272-1.899-0.41-2.934-0.41H0.008v22.686H8.88c1.501,0,2.898-0.296,4.151-0.879
              c1.25-0.582,2.34-1.398,3.24-2.427c0.895-1.022,1.598-2.237,2.092-3.612c0.491-1.369,0.74-2.871,0.74-4.464
              c0-1.015-0.107-2.011-0.319-2.959C18.572,7.424,18.26,6.522,17.856,5.692z M3.493,3.222H7.93c1.103,0,2.139,0.164,3.079,0.488
              c0.922,0.318,1.734,0.81,2.413,1.462c0.677,0.652,1.217,1.497,1.605,2.514c0.392,1.031,0.591,2.274,0.591,3.695
              c0,1.297-0.196,2.467-0.583,3.477c-0.383,1.001-0.921,1.855-1.599,2.54c-0.676,0.684-1.491,1.214-2.422,1.575
              c-0.94,0.365-1.977,0.55-3.083,0.55H3.493V3.222z"/>
              <path style="fill:#fff;" stroke='#fff' d="M32.297,5.843c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
              c0,4.719,3.537,7.89,8.802,7.89h7.511V5.846l-3.229,0L32.297,5.843z M31.996,9.289l2.267,0.134v9.79h-3.915
              c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
              C31.524,9.271,31.757,9.277,31.996,9.289z"/>
              <path style="fill:#fff;" stroke='#fff' d="M17.796,40.986c-0.127,0.253-0.254,0.498-0.377,0.731c-0.096,0.183-0.019,0.405,0.167,0.495
              c0.366,0.178,0.733,0.372,1.099,0.574c0.435-0.468,0.81-1,1.105-1.607c0.043-0.089-0.024-0.193-0.123-0.193H17.796z
              M17.753,36.992c-0.699,0.815-1.573,1.583-2.389,2.052c-0.145-0.329-0.451-0.814-0.713-1.095
              c0.946-0.408,1.981-1.254,2.68-2.162h-2.462v-1.159h2.884v-2.835h1.238v2.835h2.87v1.159H19.37
              c0.714,0.454,1.777,1.175,2.083,1.394l-0.729,1.033c-0.349-0.36-1.092-1.002-1.733-1.519v1.942h-1.238V36.992z M20.025,45.105
              c-0.32-0.267-0.728-0.564-1.194-0.845c-1.005,0.845-2.199,1.424-3.525,1.801c-0.116-0.312-0.378-0.83-0.612-1.095
              c1.122-0.283,2.156-0.721,3.045-1.363c-0.521-0.303-1.074-0.581-1.605-0.825c-0.278-0.128-0.383-0.465-0.23-0.729
              c0.191-0.328,0.383-0.695,0.583-1.061h-1.34v-1.19h1.893c0.146-0.344,0.227-0.472,0.355-0.779l1.218,0.058
              c-0.088,0.235-0.19,0.469-0.291,0.721h2.473c0.416,0,0.698,0.418,0.548,0.806c-0.411,1.062-1.032,2.066-1.638,2.78
              c0.422,0.267,0.83,0.516,1.136,0.752L20.025,45.105z M16.18,34.595c-0.117-0.547-0.481-1.394-0.859-2.02l0.99-0.439
              c0.379,0.596,0.772,1.41,0.903,1.974L16.18,34.595z M21.584,32.56c-0.437,0.704-0.903,1.456-1.297,1.942l-0.874-0.423
              c0.349-0.564,0.786-1.426,1.034-2.035L21.584,32.56z M26.958,36.099c-0.306,2.271-0.757,4.166-1.5,5.732
              c0.714,1.331,1.631,2.381,2.782,3.07c-0.306,0.251-0.685,0.783-0.889,1.129c-1.063-0.69-1.923-1.692-2.622-2.882
              c-0.83,1.269-1.908,2.287-3.336,3.085c-0.116-0.297-0.495-0.908-0.713-1.19c1.515-0.768,2.607-1.817,3.394-3.226
              c-0.481-1.127-0.874-2.381-1.165-3.758c-0.262,0.657-0.568,1.237-0.889,1.738c-0.203-0.251-0.713-0.705-1.005-0.909
              c1.136-1.644,1.791-4.244,2.127-6.985l1.238,0.187c-0.117,0.909-0.277,1.802-0.466,2.647h3.686
              c0.168,0,0.304,0.136,0.304,0.304v1.058H26.958z M23.681,36.099c0.247,1.504,0.611,2.914,1.092,4.198
              c0.422-1.222,0.728-2.6,0.932-4.198H23.681z"/>

              <path style="fill:#fff;" stroke='#fff' d="M157.635,34.803c-0.407-0.751-1.311-1.91-2.039-2.741l-1.034,0.721
              c0.728,0.877,1.587,2.083,1.966,2.85L157.635,34.803z"/>
              <path style="fill:#fff;" stroke='#fff' d="M162.325,44.295h1.398v-2.57h3.091v-1.377h-3.091v-1.785h2.747v-1.348h-2.747v-1.769h-1.398
              v1.769h-1.923c-0.14,0-0.23-0.148-0.166-0.273l1.142-2.201h5.433v-1.254l-4.903,0.008l0.6-1.115l-1.262-0.55l-0.86,1.636
              l-2.271,0.022v1.254h1.719l-1.201,2.23c-0.153,0.283-0.171,0.62-0.05,0.919h0c0.166,0.408,0.562,0.675,1.003,0.674
              c0.19-0.001,0.4-0.001,0.611-0.001h2.127v1.785h-4.218v1.377h4.218V44.295z"/>
              <path style="fill:#fff;" stroke='#fff' d="M158.13,43.934c-0.436-0.297-0.742-0.564-1.005-0.736v-6.077h-3.088v1.347h1.792v4.588
              c-0.627,0.282-1.355,0.972-2.068,1.88l0.99,1.426c0.597-1.019,1.223-2.052,1.66-2.052c0.32,0,0.83,0.548,1.442,0.955
              c1.077,0.689,2.287,0.861,4.18,0.861c1.486,0,4.05-0.093,5.069-0.172c0.029-0.439,0.262-1.205,0.422-1.629
              c-1.456,0.219-3.758,0.361-5.447,0.361C160.403,44.686,159.092,44.577,158.13,43.934z"/>

              <path style="fill:#fff;" stroke='#fff' d="M111.437,46.258v-0.002h6.556v0.002h1.416v-4.978c0-0.587-0.476-1.064-1.064-1.064h-8.279
              v6.042H111.437z M111.435,41.943h0.001v-0.541h6.244c0.172,0,0.312,0.14,0.312,0.312v0.938h-0.001v1.122h0.001v1.281h-6.556
              v-0.732h-0.001V41.943z"/>
              <path style="fill:#fff;" stroke='#fff' d="M111.585,38.198c0.715,0.528,1.684,1.281,2.116,1.666l0.969-0.977
              c-0.402-0.305-2.041-1.346-2.652-1.667l0.044-0.144h2.652V35.89h-2.444c0.015-0.16,0.015-0.32,0.015-0.48v-0.834h2.056V33.39
              h-3.859c0.119-0.352,0.238-0.689,0.343-1.057l-1.237-0.273c-0.313,1.186-0.894,2.355-1.639,3.156
              c0.283,0.129,0.79,0.481,1.058,0.673h-1.013v1.186h2.697c-0.342,0.898-1.117,1.826-2.846,2.548
              c0.313,0.24,0.701,0.704,0.879,0.993C110.185,39.912,111.064,39.062,111.585,38.198z M109.067,35.89
              c0.313-0.368,0.611-0.801,0.864-1.314h1.043v0.817c0,0.16,0,0.321-0.015,0.497H109.067z"/>
              <path style="fill:#fff;" stroke='#fff' d="M115.281,33.374v5.719h3.319c1.138,0,2.061-0.923,2.061-2.061v-3.659H115.281z M119.289,36.842
              c0,0.518-0.42,0.938-0.938,0.938h-1.774v-3.092h2.712V36.842z"/>
              <rect style="fill:#fff;" stroke='#fff' x="111.967" y="42.581" width="5.512" height="1.145"/>

              <path style="fill:#fff;" stroke='#fff' d="M61.082,37.905l0.146,1.065c1.34-0.142,3.117-0.314,4.923-0.516v0.641h1.209v-0.768
              l0.786-0.093v-0.062c0.175,0.235,0.335,0.485,0.437,0.704c0.976-0.376,1.908-0.923,2.709-1.629
              c0.816,0.548,1.529,1.097,2.025,1.551l0.859-0.987c-0.495-0.439-1.194-0.94-1.981-1.456c0.541-0.615,1.137-1.488,1.573-2.395
              c0.227-0.472-0.115-1.019-0.638-1.019l0,0h-4.736v1.158h3.544c0.152,0,0.248,0.164,0.173,0.296
              c-0.269,0.47-0.601,0.914-0.963,1.302c-0.743-0.439-1.515-0.861-2.185-1.206l-0.801,0.847
              c0.656,0.36,1.369,0.766,2.068,1.205c-0.64,0.501-1.354,0.909-2.083,1.206l0.014-0.516l-0.801,0.078v-3.822h0.873v-1.065
              h-6.89v1.065h1.078v4.308C61.942,37.826,61.476,37.873,61.082,37.905z M63.629,33.635h0.003v-0.148h2.52v0.752h-0.001v0.861
              h0.001v0.768h-0.001v0.862h0.001v0.704c-0.874,0.094-1.719,0.172-2.52,0.251v-0.563h-0.003V33.635z"/>
              <path style="fill:#fff;" stroke='#fff' d="M62.117,43.214c1.573-0.329,3.569-0.925,4.996-1.519l-1.15-0.658
              c-1.253,0.469-3.161,0.908-4.836,1.175C61.432,42.431,61.898,42.964,62.117,43.214z"/>
              <path style="fill:#fff;" stroke='#fff' d="M70.492,42.885c1.049-0.454,2.287-1.08,3.278-1.706l-1.092-0.768
              c-0.801,0.564-2.097,1.299-3.147,1.785c-0.422-0.344-0.771-0.721-1.063-1.127v-0.721c1.631-0.189,3.205-0.423,4.443-0.69
              l-0.961-0.923c-2.433,0.485-6.657,0.83-9.949,0.83c0.234,0.297,0.554,0.923,0.714,1.237c1.34-0.062,2.87-0.172,4.413-0.314
              v2.82l-0.859-0.486c-1.296,0.721-3.394,1.426-5.258,1.817c0.321,0.25,0.83,0.783,1.092,1.08
              c1.588-0.454,3.569-1.19,5.025-1.973v2.552h1.34V42.76c1.369,1.379,3.278,2.334,5.375,2.82
              c0.175-0.376,0.539-0.909,0.801-1.191C73.099,44.138,71.672,43.605,70.492,42.885z"/>

              <rect style="fill:#fff;" stroke='#fff' x="63.941" y="34.274" width="1.876" height="0.829"/>
              <rect style="fill:#fff;" stroke='#fff' x="63.941" y="35.718" width="1.876" height="0.829"/>

              <path style="fill:#fff;" stroke='#fff' d="M174.477,12.463c0.992,1.685,2.009,3.398,3.051,5.137c1.041,1.74,2.058,3.452,3.051,5.137h-4.368
              l-4.433-7.567c-0.251,0.25-0.486,0.484-0.704,0.701c-0.218,0.218-0.415,0.418-0.589,0.603c-0.196,0.207-0.387,0.402-0.573,0.587
              v5.675h-3.86V0.004h3.86v12.215l6.2-6.083h4.711L174.477,12.463z"/>
              <path style="fill:#fff;" stroke='#fff' d="M108.228,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
              c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
              V8.92h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372V8.92h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
              c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C107.224,22.64,107.715,22.744,108.228,22.744
              C108.227,22.744,108.228,22.744,108.228,22.744z"/>
              <!-- <rect style="fill:#fff;" stroke='#fff' x="109.334" y="19.6" style="fill:#fff;" width="2.299" height="0.56"/> -->
              <path style="fill:#fff;" stroke='#fff' d="M46.211,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
              c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
              V8.921h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372v3.157h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
              c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C45.207,22.64,45.698,22.744,46.211,22.744
              C46.211,22.744,46.211,22.744,46.211,22.744z"/>
              <path style="fill:#fff;" stroke='#fff' d="M61.526,5.911c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
              c0,4.719,3.537,7.89,8.802,7.89h7.511V5.914l-3.229,0L61.526,5.911z M61.225,9.357l2.267,0.134v9.79h-3.915
              c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
              C60.753,9.339,60.986,9.345,61.225,9.357z"/>
              <path style="fill:#fff;" stroke='#fff' d="M148.439,5.845h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
              c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
              c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
              c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
              c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
              c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.845z"/>

              </svg>
            </div>

          </div>
        </div>
      </div>

      <div class="titleTY" style="margin-top:60px;">
        <span class="titleTY_top">
          办公地点
        </span>
        <span class="titleTY_bot">
          Office Address
        </span>
      </div>

      <div class="relationAdress contentWidth">
        <div class="relationAddressInfo">
          <h2>北京总部</h2>
          <p>
            <span class="newAddressInfo">
              
                <!-- <svg class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="7945" width="200" height="200"><path d="M511.744 68.266667c-173.5168 0-314.026667 136.311467-314.7776 305.937066 0 60.910933 18.1248 118.903467 51.7632 168.465067l3.293867 4.693333 1.911466 3.1744 1.570134 2.389334c1.058133 1.553067 2.184533 3.037867 3.447466 4.5056l0.785067 0.853333 200.174933 232.823467a68.266667 68.266667 0 0 0 103.645867-0.170667L762.641067 558.08l-1.314134 1.450667a50.346667 50.346667 0 0 0 5.341867-6.621867l1.536-2.3552c0.631467-0.989867 1.860267-3.072 1.826133-3.003733 35.293867-49.322667 55.0912-109.431467 55.825067-172.782934C825.856 204.9536 684.970667 68.266667 511.744 68.266667z m0 68.266666c135.970133 0 245.845333 106.5984 245.845333 237.824a235.400533 235.400533 0 0 1-43.9808 134.775467l-2.952533 4.676267-198.997333 232.789333-200.192-232.823467-1.928534-3.191466-0.989866-1.450667a230.229333 230.229333 0 0 1-43.3152-134.775467C265.8304 242.858667 375.415467 136.533333 511.744 136.533333z" fill="#80888f" p-id="7946" data-spm-anchor-id="a313x.search_index.0.i7.6e8f3a816TDhEv" class="selected"></path><path d="M783.803733 714.734933a34.133333 34.133333 0 0 1 45.243734 10.018134l1.4336 2.2528 73.386666 125.730133a68.266667 68.266667 0 0 1-54.784 102.5536l-4.5568 0.119467-666.043733-3.6352a68.266667 68.266667 0 0 1-60.654933-98.850134l2.133333-3.9424 69.9392-119.261866a34.133333 34.133333 0 0 1 60.16 32.170666l-1.262933 2.3552-69.9392 119.261867 666.043733 3.6352-73.386667-125.730133a34.133333 34.133333 0 0 1 12.288-46.677334z" fill="#80888f" p-id="7947" data-spm-anchor-id="a313x.search_index.0.i8.6e8f3a816TDhEv" class="selected"></path><path d="M512 243.950933a136.533333 136.533333 0 1 0 0.034133 273.1008A136.533333 136.533333 0 0 0 512 243.950933z m0 68.266667a68.266667 68.266667 0 1 1-0.034133 136.567467A68.266667 68.266667 0 0 1 512 312.2176z" fill="#0168b7" p-id="7948" data-spm-anchor-id="a313x.search_index.0.i3.6e8f3a816TDhEv" class=""></path></svg> -->
              
              <span>北京市朝阳区酒仙桥北路甲10号院IT产业园102号楼3层</span>
            </span>
            <br>
            <span class="newAddressInfo">
              
                <!-- <svg class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="3132" width="200" height="200"><path d="M284.484267 128.546133c-136.669867 101.973333-153.6 325.717333-32.034134 551.253334 118.801067 220.3648 307.063467 337.442133 501.725867 277.333333 50.602667-15.616 99.157333-58.862933 99.157333-107.5712 0.017067-84.667733-96.8704-253.269333-169.437866-266.359467-20.360533-3.652267-44.970667 3.6864-81.578667 19.490134-3.7888 1.6384-7.68 3.362133-11.6736 5.1712l-9.1136 4.1984c-8.9088 4.1472-16.401067 7.7824-29.1328 14.08l-5.4784 2.696533-0.256-0.238933a122.043733 122.043733 0 0 1-6.638933-6.9632c-10.496-11.844267-22.869333-29.2864-35.345067-49.800534l-3.618133-6.0416c-16.759467-28.330667-31.6416-58.811733-41.3184-84.206933l-0.904534-2.440533 23.125334-9.898667c4.778667-2.048 9.335467-4.078933 14.114133-6.212267l13.482667-6.0928 10.376533-4.829866c26.282667-12.4416 41.8816-21.4528 50.653867-30.993067C620.714667 366.557867 521.352533 103.082667 439.825067 87.893333c-48.503467-9.045333-107.1104 6.7072-150.5792 37.205334l-4.778667 3.447466z m142.830933 26.453334c10.410667 1.9456 40.7552 48.810667 63.5392 109.226666 11.383467 30.1568 20.002133 60.586667 24.029867 84.599467l0.682666 4.164267a139.946667 139.946667 0 0 1 1.774934 20.48l-0.1024 3.140266-4.3008 2.474667-2.3552 1.314133c-7.543467 4.096-17.527467 8.994133-29.559467 14.523734l-19.797333 8.891733c-6.997333 3.072-14.062933 6.144-22.715734 9.813333l-31.402666 13.3632-4.676267 2.184534-1.570133 0.836266-0.887467-0.887466c-1.877333-1.28-3.498667 3.293867-15.991467 38.775466 20.736 88.814933 108.3392 232.942933 162.133334 233.028267l6.638933-0.733867c1.416533-0.170667 2.218667-0.324267 2.952533-0.529066l4.539734-1.621334 3.908266-1.6896 14.08-6.826666 23.944534-11.7248c3.6864-1.757867 7.168-3.413333 11.0592-5.205334l10.922666-4.949333 5.2224-2.286933a303.8208 303.8208 0 0 1 31.9488-12.100267l3.805867-1.058133c4.608-1.2288 7.338667-1.6896 6.656-1.809067 34.133333 6.144 113.288533 143.872 113.271467 199.168 0 11.605333-25.736533 34.542933-51.029334 42.359467-158.037333 48.7936-316.484267-49.732267-421.495466-244.5312-107.076267-198.6048-92.928-385.262933 12.765866-464.128 29.422933-21.9648 71.697067-33.911467 102.007467-28.2624z" fill="#80888f" p-id="3133" data-spm-anchor-id="a313x.collections_detail.0.i0.3cb73a81rtyKOs" class=""></path><path d="M670.1056 75.946667c92.9792 75.776 120.149333 191.3344 79.906133 305.373866l-2.218666 6.109867-63.931734-23.927467c32.836267-87.773867 14.848-173.192533-52.5312-230.997333l-4.369066-3.652267 43.144533-52.906666z" fill="#0168b7" p-id="3134" data-spm-anchor-id="a313x.collections_detail.0.i3.3cb73a81rtyKOs" class="selected"></path></svg> -->
                
              <span>010-59547322</span>
            </span>
            <br>
            <span class="newAddressInfo" style="margin-top:-4px;">
              <!-- <svg version="1.1" id="图层_1" x="0px" y="0px" viewBox="0 0 792 543.451" style="enable-background:new 0 0 792 543.451;" xml:space="preserve">
                
                    <defs>
                      <rect id="SVGID_1_" x="41" y="-2.394" width="709.92" height="547.92"/>
                    </defs>
                    <clipPath id="SVGID_2_">
                      <use xlink:href="#SVGID_1_" style="overflow:visible;"/>
                    </clipPath>
                    <path style="clip-path:url(#SVGID_2_);fill:#80888F;" d="M696.359-1.567H95.613C65.453-1.567,41,22.886,41,53.046v436.906    c0,30.164,24.453,54.613,54.613,54.613h600.746c30.164,0,54.614-24.449,54.614-54.613V53.046    C750.973,22.886,726.523-1.567,696.359-1.567L696.359-1.567z M95.613,53.046h600.746v436.906H95.613V53.046z M95.613,53.046"/>
                  
                  <path style="fill:#80888F;" d="M354.033,328.258L104.274,78.499c-9.463-9.463-16.503-20.574-19.573-30.887   c-3.07-10.312-1.915-18.98,3.206-24.101l19.308-19.308l321.114,321.114l-19.308,19.308c-5.121,5.121-13.789,6.276-24.101,3.206   C374.607,344.76,363.496,337.72,354.033,328.258L354.033,328.258z"/>
                  <path style="fill:#80888F;" d="M693.877,78.652L443.045,329.485c-9.503,9.503-20.654,16.582-30.995,19.681   c-10.341,3.099-19.025,1.96-24.146-3.161l-19.308-19.308L691.09,4.203l19.308,19.308c5.121,5.121,6.26,13.805,3.161,24.146   C710.46,57.998,703.38,69.149,693.877,78.652L693.877,78.652z"/>
                  <path style="fill:#80888F;" d="M453-2.394"/>
                
                </svg> -->
               
              <span><a href="mailto:yunying@intelinkgroup.com">yunying@intelinkgroup.com</a></span>
            </span>
            
          </p>
        </div>
        <div class="relationAddressInfo">
          <h2>杭州公司</h2>
          <p>
            
            <span class="newAddressInfo">
                
                <!-- <svg class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="7945" width="200" height="200"><path d="M511.744 68.266667c-173.5168 0-314.026667 136.311467-314.7776 305.937066 0 60.910933 18.1248 118.903467 51.7632 168.465067l3.293867 4.693333 1.911466 3.1744 1.570134 2.389334c1.058133 1.553067 2.184533 3.037867 3.447466 4.5056l0.785067 0.853333 200.174933 232.823467a68.266667 68.266667 0 0 0 103.645867-0.170667L762.641067 558.08l-1.314134 1.450667a50.346667 50.346667 0 0 0 5.341867-6.621867l1.536-2.3552c0.631467-0.989867 1.860267-3.072 1.826133-3.003733 35.293867-49.322667 55.0912-109.431467 55.825067-172.782934C825.856 204.9536 684.970667 68.266667 511.744 68.266667z m0 68.266666c135.970133 0 245.845333 106.5984 245.845333 237.824a235.400533 235.400533 0 0 1-43.9808 134.775467l-2.952533 4.676267-198.997333 232.789333-200.192-232.823467-1.928534-3.191466-0.989866-1.450667a230.229333 230.229333 0 0 1-43.3152-134.775467C265.8304 242.858667 375.415467 136.533333 511.744 136.533333z" fill="#80888f" p-id="7946" data-spm-anchor-id="a313x.search_index.0.i7.6e8f3a816TDhEv" class="selected"></path><path d="M783.803733 714.734933a34.133333 34.133333 0 0 1 45.243734 10.018134l1.4336 2.2528 73.386666 125.730133a68.266667 68.266667 0 0 1-54.784 102.5536l-4.5568 0.119467-666.043733-3.6352a68.266667 68.266667 0 0 1-60.654933-98.850134l2.133333-3.9424 69.9392-119.261866a34.133333 34.133333 0 0 1 60.16 32.170666l-1.262933 2.3552-69.9392 119.261867 666.043733 3.6352-73.386667-125.730133a34.133333 34.133333 0 0 1 12.288-46.677334z" fill="#80888f" p-id="7947" data-spm-anchor-id="a313x.search_index.0.i8.6e8f3a816TDhEv" class="selected"></path><path d="M512 243.950933a136.533333 136.533333 0 1 0 0.034133 273.1008A136.533333 136.533333 0 0 0 512 243.950933z m0 68.266667a68.266667 68.266667 0 1 1-0.034133 136.567467A68.266667 68.266667 0 0 1 512 312.2176z" fill="#0168b7" p-id="7948" data-spm-anchor-id="a313x.search_index.0.i3.6e8f3a816TDhEv" class=""></path></svg> -->
              
              <span>杭州市西湖区黄龙时代广场B座15层</span>
            </span>

          </p>
        </div>
        <div class="relationAddressInfo">
          <h2>上海公司</h2>
          <p>
            
            <span class="newAddressInfo">
                
                <!-- <svg class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="7945" width="200" height="200"><path d="M511.744 68.266667c-173.5168 0-314.026667 136.311467-314.7776 305.937066 0 60.910933 18.1248 118.903467 51.7632 168.465067l3.293867 4.693333 1.911466 3.1744 1.570134 2.389334c1.058133 1.553067 2.184533 3.037867 3.447466 4.5056l0.785067 0.853333 200.174933 232.823467a68.266667 68.266667 0 0 0 103.645867-0.170667L762.641067 558.08l-1.314134 1.450667a50.346667 50.346667 0 0 0 5.341867-6.621867l1.536-2.3552c0.631467-0.989867 1.860267-3.072 1.826133-3.003733 35.293867-49.322667 55.0912-109.431467 55.825067-172.782934C825.856 204.9536 684.970667 68.266667 511.744 68.266667z m0 68.266666c135.970133 0 245.845333 106.5984 245.845333 237.824a235.400533 235.400533 0 0 1-43.9808 134.775467l-2.952533 4.676267-198.997333 232.789333-200.192-232.823467-1.928534-3.191466-0.989866-1.450667a230.229333 230.229333 0 0 1-43.3152-134.775467C265.8304 242.858667 375.415467 136.533333 511.744 136.533333z" fill="#80888f" p-id="7946" data-spm-anchor-id="a313x.search_index.0.i7.6e8f3a816TDhEv" class="selected"></path><path d="M783.803733 714.734933a34.133333 34.133333 0 0 1 45.243734 10.018134l1.4336 2.2528 73.386666 125.730133a68.266667 68.266667 0 0 1-54.784 102.5536l-4.5568 0.119467-666.043733-3.6352a68.266667 68.266667 0 0 1-60.654933-98.850134l2.133333-3.9424 69.9392-119.261866a34.133333 34.133333 0 0 1 60.16 32.170666l-1.262933 2.3552-69.9392 119.261867 666.043733 3.6352-73.386667-125.730133a34.133333 34.133333 0 0 1 12.288-46.677334z" fill="#80888f" p-id="7947" data-spm-anchor-id="a313x.search_index.0.i8.6e8f3a816TDhEv" class="selected"></path><path d="M512 243.950933a136.533333 136.533333 0 1 0 0.034133 273.1008A136.533333 136.533333 0 0 0 512 243.950933z m0 68.266667a68.266667 68.266667 0 1 1-0.034133 136.567467A68.266667 68.266667 0 0 1 512 312.2176z" fill="#0168b7" p-id="7948" data-spm-anchor-id="a313x.search_index.0.i3.6e8f3a816TDhEv" class=""></path></svg> -->
              
              <span>上海市徐汇区南宁路1000号徐汇万科C座2004室</span>
            </span>
            
          </p>
        </div>
      </div>

      <div class="newAdress" v-if="false">
        <div class="newAdressImg">
          <img src="../../assets/img/relation/b.png" alt="">
        </div>
        <div class="newAdressItem">
          <h2>北京总部</h2>
          <p>
            <span class="newAddressInfo">
              
                <svg class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="7945" width="200" height="200"><path d="M511.744 68.266667c-173.5168 0-314.026667 136.311467-314.7776 305.937066 0 60.910933 18.1248 118.903467 51.7632 168.465067l3.293867 4.693333 1.911466 3.1744 1.570134 2.389334c1.058133 1.553067 2.184533 3.037867 3.447466 4.5056l0.785067 0.853333 200.174933 232.823467a68.266667 68.266667 0 0 0 103.645867-0.170667L762.641067 558.08l-1.314134 1.450667a50.346667 50.346667 0 0 0 5.341867-6.621867l1.536-2.3552c0.631467-0.989867 1.860267-3.072 1.826133-3.003733 35.293867-49.322667 55.0912-109.431467 55.825067-172.782934C825.856 204.9536 684.970667 68.266667 511.744 68.266667z m0 68.266666c135.970133 0 245.845333 106.5984 245.845333 237.824a235.400533 235.400533 0 0 1-43.9808 134.775467l-2.952533 4.676267-198.997333 232.789333-200.192-232.823467-1.928534-3.191466-0.989866-1.450667a230.229333 230.229333 0 0 1-43.3152-134.775467C265.8304 242.858667 375.415467 136.533333 511.744 136.533333z" fill="#80888f" p-id="7946" data-spm-anchor-id="a313x.search_index.0.i7.6e8f3a816TDhEv" class="selected"></path><path d="M783.803733 714.734933a34.133333 34.133333 0 0 1 45.243734 10.018134l1.4336 2.2528 73.386666 125.730133a68.266667 68.266667 0 0 1-54.784 102.5536l-4.5568 0.119467-666.043733-3.6352a68.266667 68.266667 0 0 1-60.654933-98.850134l2.133333-3.9424 69.9392-119.261866a34.133333 34.133333 0 0 1 60.16 32.170666l-1.262933 2.3552-69.9392 119.261867 666.043733 3.6352-73.386667-125.730133a34.133333 34.133333 0 0 1 12.288-46.677334z" fill="#80888f" p-id="7947" data-spm-anchor-id="a313x.search_index.0.i8.6e8f3a816TDhEv" class="selected"></path><path d="M512 243.950933a136.533333 136.533333 0 1 0 0.034133 273.1008A136.533333 136.533333 0 0 0 512 243.950933z m0 68.266667a68.266667 68.266667 0 1 1-0.034133 136.567467A68.266667 68.266667 0 0 1 512 312.2176z" fill="#0168b7" p-id="7948" data-spm-anchor-id="a313x.search_index.0.i3.6e8f3a816TDhEv" class=""></path></svg>
              
              <span>北京市朝阳区酒仙桥北路甲10号院IT产业园102号楼3层</span>
            </span>
            <br>
            <span class="newAddressInfo">
              
                <svg class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="3132" width="200" height="200"><path d="M284.484267 128.546133c-136.669867 101.973333-153.6 325.717333-32.034134 551.253334 118.801067 220.3648 307.063467 337.442133 501.725867 277.333333 50.602667-15.616 99.157333-58.862933 99.157333-107.5712 0.017067-84.667733-96.8704-253.269333-169.437866-266.359467-20.360533-3.652267-44.970667 3.6864-81.578667 19.490134-3.7888 1.6384-7.68 3.362133-11.6736 5.1712l-9.1136 4.1984c-8.9088 4.1472-16.401067 7.7824-29.1328 14.08l-5.4784 2.696533-0.256-0.238933a122.043733 122.043733 0 0 1-6.638933-6.9632c-10.496-11.844267-22.869333-29.2864-35.345067-49.800534l-3.618133-6.0416c-16.759467-28.330667-31.6416-58.811733-41.3184-84.206933l-0.904534-2.440533 23.125334-9.898667c4.778667-2.048 9.335467-4.078933 14.114133-6.212267l13.482667-6.0928 10.376533-4.829866c26.282667-12.4416 41.8816-21.4528 50.653867-30.993067C620.714667 366.557867 521.352533 103.082667 439.825067 87.893333c-48.503467-9.045333-107.1104 6.7072-150.5792 37.205334l-4.778667 3.447466z m142.830933 26.453334c10.410667 1.9456 40.7552 48.810667 63.5392 109.226666 11.383467 30.1568 20.002133 60.586667 24.029867 84.599467l0.682666 4.164267a139.946667 139.946667 0 0 1 1.774934 20.48l-0.1024 3.140266-4.3008 2.474667-2.3552 1.314133c-7.543467 4.096-17.527467 8.994133-29.559467 14.523734l-19.797333 8.891733c-6.997333 3.072-14.062933 6.144-22.715734 9.813333l-31.402666 13.3632-4.676267 2.184534-1.570133 0.836266-0.887467-0.887466c-1.877333-1.28-3.498667 3.293867-15.991467 38.775466 20.736 88.814933 108.3392 232.942933 162.133334 233.028267l6.638933-0.733867c1.416533-0.170667 2.218667-0.324267 2.952533-0.529066l4.539734-1.621334 3.908266-1.6896 14.08-6.826666 23.944534-11.7248c3.6864-1.757867 7.168-3.413333 11.0592-5.205334l10.922666-4.949333 5.2224-2.286933a303.8208 303.8208 0 0 1 31.9488-12.100267l3.805867-1.058133c4.608-1.2288 7.338667-1.6896 6.656-1.809067 34.133333 6.144 113.288533 143.872 113.271467 199.168 0 11.605333-25.736533 34.542933-51.029334 42.359467-158.037333 48.7936-316.484267-49.732267-421.495466-244.5312-107.076267-198.6048-92.928-385.262933 12.765866-464.128 29.422933-21.9648 71.697067-33.911467 102.007467-28.2624z" fill="#80888f" p-id="3133" data-spm-anchor-id="a313x.collections_detail.0.i0.3cb73a81rtyKOs" class=""></path><path d="M670.1056 75.946667c92.9792 75.776 120.149333 191.3344 79.906133 305.373866l-2.218666 6.109867-63.931734-23.927467c32.836267-87.773867 14.848-173.192533-52.5312-230.997333l-4.369066-3.652267 43.144533-52.906666z" fill="#0168b7" p-id="3134" data-spm-anchor-id="a313x.collections_detail.0.i3.3cb73a81rtyKOs" class="selected"></path></svg>
              
              <span>010-59547322</span>
            </span>
            <br>
            <span class="newAddressInfo" style="margin-top:-4px;">
              <svg version="1.1" id="图层_1" x="0px" y="0px" viewBox="0 0 792 543.451" style="enable-background:new 0 0 792 543.451;" xml:space="preserve">
                
                    <defs>
                      <rect id="SVGID_1_" x="41" y="-2.394" width="709.92" height="547.92"/>
                    </defs>
                    <clipPath id="SVGID_2_">
                      <use xlink:href="#SVGID_1_" style="overflow:visible;"/>
                    </clipPath>
                    <path style="clip-path:url(#SVGID_2_);fill:#80888F;" d="M696.359-1.567H95.613C65.453-1.567,41,22.886,41,53.046v436.906    c0,30.164,24.453,54.613,54.613,54.613h600.746c30.164,0,54.614-24.449,54.614-54.613V53.046    C750.973,22.886,726.523-1.567,696.359-1.567L696.359-1.567z M95.613,53.046h600.746v436.906H95.613V53.046z M95.613,53.046"/>
                  
                  <path style="fill:#80888F;" d="M354.033,328.258L104.274,78.499c-9.463-9.463-16.503-20.574-19.573-30.887   c-3.07-10.312-1.915-18.98,3.206-24.101l19.308-19.308l321.114,321.114l-19.308,19.308c-5.121,5.121-13.789,6.276-24.101,3.206   C374.607,344.76,363.496,337.72,354.033,328.258L354.033,328.258z"/>
                  <path style="fill:#80888F;" d="M693.877,78.652L443.045,329.485c-9.503,9.503-20.654,16.582-30.995,19.681   c-10.341,3.099-19.025,1.96-24.146-3.161l-19.308-19.308L691.09,4.203l19.308,19.308c5.121,5.121,6.26,13.805,3.161,24.146   C710.46,57.998,703.38,69.149,693.877,78.652L693.877,78.652z"/>
                  <path style="fill:#80888F;" d="M453-2.394"/>
                
                </svg>

              <span><a href="mailto:yunying@intelinkgroup.com">yunying@intelinkgroup.com</a></span>
            </span>
            
          </p>
        </div>

      </div>

      
      <div class="newAdress" v-if="false">
        <div class="newAdressImg">
          <img src="../../assets/img/relation/h.png" alt="">
        </div>
        <div class="newAdressItem">
          <h2>杭州公司</h2>
          <p>
            
            <span class="newAddressInfo">
                
                <svg class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="7945" width="200" height="200"><path d="M511.744 68.266667c-173.5168 0-314.026667 136.311467-314.7776 305.937066 0 60.910933 18.1248 118.903467 51.7632 168.465067l3.293867 4.693333 1.911466 3.1744 1.570134 2.389334c1.058133 1.553067 2.184533 3.037867 3.447466 4.5056l0.785067 0.853333 200.174933 232.823467a68.266667 68.266667 0 0 0 103.645867-0.170667L762.641067 558.08l-1.314134 1.450667a50.346667 50.346667 0 0 0 5.341867-6.621867l1.536-2.3552c0.631467-0.989867 1.860267-3.072 1.826133-3.003733 35.293867-49.322667 55.0912-109.431467 55.825067-172.782934C825.856 204.9536 684.970667 68.266667 511.744 68.266667z m0 68.266666c135.970133 0 245.845333 106.5984 245.845333 237.824a235.400533 235.400533 0 0 1-43.9808 134.775467l-2.952533 4.676267-198.997333 232.789333-200.192-232.823467-1.928534-3.191466-0.989866-1.450667a230.229333 230.229333 0 0 1-43.3152-134.775467C265.8304 242.858667 375.415467 136.533333 511.744 136.533333z" fill="#80888f" p-id="7946" data-spm-anchor-id="a313x.search_index.0.i7.6e8f3a816TDhEv" class="selected"></path><path d="M783.803733 714.734933a34.133333 34.133333 0 0 1 45.243734 10.018134l1.4336 2.2528 73.386666 125.730133a68.266667 68.266667 0 0 1-54.784 102.5536l-4.5568 0.119467-666.043733-3.6352a68.266667 68.266667 0 0 1-60.654933-98.850134l2.133333-3.9424 69.9392-119.261866a34.133333 34.133333 0 0 1 60.16 32.170666l-1.262933 2.3552-69.9392 119.261867 666.043733 3.6352-73.386667-125.730133a34.133333 34.133333 0 0 1 12.288-46.677334z" fill="#80888f" p-id="7947" data-spm-anchor-id="a313x.search_index.0.i8.6e8f3a816TDhEv" class="selected"></path><path d="M512 243.950933a136.533333 136.533333 0 1 0 0.034133 273.1008A136.533333 136.533333 0 0 0 512 243.950933z m0 68.266667a68.266667 68.266667 0 1 1-0.034133 136.567467A68.266667 68.266667 0 0 1 512 312.2176z" fill="#0168b7" p-id="7948" data-spm-anchor-id="a313x.search_index.0.i3.6e8f3a816TDhEv" class=""></path></svg>
              
              <span>杭州市西湖区黄龙时代广场B座15层</span>
            </span>

          </p>
        </div>

      </div>

      
      <div class="newAdress" v-if="false">
        <div class="newAdressImg">
          <img src="../../assets/img/relation/s.png" alt="">
        </div>
        <div class="newAdressItem">
          <h2>上海公司</h2>
          <p>
            
            <span class="newAddressInfo">
                
                <svg class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="7945" width="200" height="200"><path d="M511.744 68.266667c-173.5168 0-314.026667 136.311467-314.7776 305.937066 0 60.910933 18.1248 118.903467 51.7632 168.465067l3.293867 4.693333 1.911466 3.1744 1.570134 2.389334c1.058133 1.553067 2.184533 3.037867 3.447466 4.5056l0.785067 0.853333 200.174933 232.823467a68.266667 68.266667 0 0 0 103.645867-0.170667L762.641067 558.08l-1.314134 1.450667a50.346667 50.346667 0 0 0 5.341867-6.621867l1.536-2.3552c0.631467-0.989867 1.860267-3.072 1.826133-3.003733 35.293867-49.322667 55.0912-109.431467 55.825067-172.782934C825.856 204.9536 684.970667 68.266667 511.744 68.266667z m0 68.266666c135.970133 0 245.845333 106.5984 245.845333 237.824a235.400533 235.400533 0 0 1-43.9808 134.775467l-2.952533 4.676267-198.997333 232.789333-200.192-232.823467-1.928534-3.191466-0.989866-1.450667a230.229333 230.229333 0 0 1-43.3152-134.775467C265.8304 242.858667 375.415467 136.533333 511.744 136.533333z" fill="#80888f" p-id="7946" data-spm-anchor-id="a313x.search_index.0.i7.6e8f3a816TDhEv" class="selected"></path><path d="M783.803733 714.734933a34.133333 34.133333 0 0 1 45.243734 10.018134l1.4336 2.2528 73.386666 125.730133a68.266667 68.266667 0 0 1-54.784 102.5536l-4.5568 0.119467-666.043733-3.6352a68.266667 68.266667 0 0 1-60.654933-98.850134l2.133333-3.9424 69.9392-119.261866a34.133333 34.133333 0 0 1 60.16 32.170666l-1.262933 2.3552-69.9392 119.261867 666.043733 3.6352-73.386667-125.730133a34.133333 34.133333 0 0 1 12.288-46.677334z" fill="#80888f" p-id="7947" data-spm-anchor-id="a313x.search_index.0.i8.6e8f3a816TDhEv" class="selected"></path><path d="M512 243.950933a136.533333 136.533333 0 1 0 0.034133 273.1008A136.533333 136.533333 0 0 0 512 243.950933z m0 68.266667a68.266667 68.266667 0 1 1-0.034133 136.567467A68.266667 68.266667 0 0 1 512 312.2176z" fill="#0168b7" p-id="7948" data-spm-anchor-id="a313x.search_index.0.i3.6e8f3a816TDhEv" class=""></path></svg>
              
              <span>上海市徐汇区南宁路1000号徐汇万科C座2004室</span>
            </span>
            
          </p>
        </div>

      </div>



    </div>


    <div class="contentWidth" v-if="false">
      <!-- <div :class="'address '+(addressIndex==1?'addressChange':'')" @mouseover='addressHover(1)' @mouseleave='addressLeave()'> -->
      <div class="address">
        <img src="../../assets/img/relation/bj.png" alt="">
        <div class="addressZZ">

        </div>
        <div class="addressKP">
          <h2>北京总部</h2>
          <p>
            <span>
              <!-- 地址：北京市朝阳区酒仙桥14号兆维工业园区C3座3层 -->
              地址：北京市朝阳区酒仙桥北路甲10号院IT产业园102号楼3层
            </span><br>
            <span>
              联系方式：010-59547322
            </span><br>
            <span>
              邮箱：<a href="mailto:yunying@intelinkgroup.com">yunying@intelinkgroup.com</a>
            </span>
          </p>
        </div>
      </div>
      
      <!-- <div :class="'address '+(addressIndex==4?'addressChange':'')" @mouseover='addressHover(4)' @mouseleave='addressLeave()'> -->
      <div class="address">
        <img src="../../assets/img/relation/hz.png" alt="">
        <div class="addressZZ">

        </div>
        <div class="addressKP">
          <h2>杭州公司</h2>
          <p>
            <span>
              地址：杭州市西湖区黄龙时代广场B座15层
            </span><br>
            <span>
              <!-- 联系方式：0571-28255058 -->
            </span><br>
            <span>
              <!-- 邮箱：<a href="mailto:yunying@intelinkgroup.com">yunying@intelinkgroup.com</a> -->
            </span>
          </p>
        </div>
      </div>
      
      <!-- <div :class="'address '+(addressIndex==2?'addressChange':'')" @mouseover='addressHover(2)' @mouseleave='addressLeave()'> -->
      <div class="address">
        <img src="../../assets/img/relation/sh.png" alt="">
        <div class="addressZZ">

        </div>
        <div class="addressKP">
          <h2>上海公司</h2>
          <p>
            <span>
              地址：上海市徐汇区南宁路1000号徐汇万科C座2004室
            </span><br>
            <span>
              <!-- 联系方式：021-60334022 -->
            </span><br>
            <span>
              <!-- 邮箱：<a href="mailto:yunying@intelinkgroup.com">yunying@intelinkgroup.com</a> -->
            </span>
          </p>
        </div>
      </div>
      

      
    </div>
    
  </div>
</template>

<script>
import ZSelect from '../modules/Zselect'
export default {
  name: 'relation',
  components:{ZSelect},
  data () {
    return {
      addressIndex:8,
      ImgHover:3,
    }
  },
  methods: {
    ImgMouse(data){
      
      this.ImgHover = data;
    },
    addressHover(data){
      this.addressIndex = data
    },
    addressLeave(){
      this.addressIndex = 8
    }
  },
  mounted(){
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less"> 
.relation{
  
  min-height: calc(100vh - 200px);
padding-bottom: 50px;
  
  .relationIcon12Zhe{
    display: inline-block;
    width: 100%;
    height: 100%;
    opacity: 0;
    position: absolute;
    left: 0;
    top:0;
    background: rgba(0,104,183,0.8);
    z-index: 2;
    transition: all 1s;
    -moz-transition: all 1s;	/* Firefox 4 */
    -webkit-transition: all 1s;	/* Safari 和 Chrome */
    -o-transition: all 1s;	/* Opera */
    span{
      display: inline-block;
      width: 80px;
      height: 80px;
      background: url('../../assets/img/index/add.png') no-repeat center;
      background-size: cover;
      position: absolute;
      top: 20px;
      left: 20px;
      transition: all 1s ease-out;
      -moz-transition: all 1s ease-out;	/* Firefox 4 */
      -webkit-transition: all 1s ease-out;	/* Safari 和 Chrome */
      -o-transition: all 1s ease-out;	/* Opera */
    }
    img{
      position: absolute;
      top:0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 50%;
    }
    
  svg{
    width:200px;
    position: absolute;
    margin: auto;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }
  path,rect {
      stroke-dasharray: 140;
      stroke-dashoffset: 0;
      /* animation: dash 3s linear infinite; */
      animation: dash 1.5s linear 1;
      animation-fill-mode: forwards;
      /* 填充的透明度 */
      fill-opacity:0;
      /* 描边宽度 */
      stroke-width:0.7;
      /* 描边画笔是圆头 */
      stroke-linecap:'round';
      /* 描边画笔拐角是圆头 */
      stroke-linejoin:'round';
  }
  
@keyframes dash {
    0% {
        stroke-dashoffset: 140;
    }
    30% {
        fill-opacity:0;
        stroke-width:0.7;
    }
    100% {
        stroke-dashoffset: 0;
        stroke-width:0.0;
        fill-opacity:1;
    }
}

  }

    
  .relationConcant{
    height: 402px;
    
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    .relationConcantTB{
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    .relationConcantTB:nth-of-type(1){
      width: 200%;
      margin-right: 4px;
    }
    .relationConcantLR{
      height: 50%;
      width: 100%;
      
      position: relative;
      img{
        width: 100%;
        height: 100%;

      }
    }
  };
  .address{
    height:300px;
    width: 900px;
    margin: 40px auto;
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: relative;
    /*border-radius: 10px !important;*/
    overflow: hidden;
    img{
      transition: all 1s;
      -moz-transition: all 1s;	/* Firefox 4 */
      -webkit-transition: all 1s;	/* Safari 和 Chrome */
      -o-transition: all 1s;	/* Opera */
    }
    .addressKP{
      a{
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        text-decoration:none !important;
        out-line: none !important;
        color: #80888f !important;
      }
      display: inline-block;
      
      height: 100%;
      width: 40%;
      background: #F2F6FC;
      flex-shrink:0;
      z-index: 3;
      right: 0;
      transition: all 1s;
      -moz-transition: all 1s;	/* Firefox 4 */
      -webkit-transition: all 1s;	/* Safari 和 Chrome */
      -o-transition: all 1s;	/* Opera */
      display: flex;
      flex-direction: column;
      align-items: center;
      h2{
        font-size: 20px;
        color: #0168b7;
        margin-bottom: 0;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        font-weight: 400;
      }
      p{
        display: inline-block;
        width: 250px;
        font-size: 14px;
        font-weight: 400;
        color: #80888f;
        text-align: left;
        line-height: 24px;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        span{
        }
      }
    }
    .addressZZ{
      display: inline-block;
      position: absolute;
      height: 100%;
      width: 100%;
      background: rgba(0,0,0,0);
      z-index: 3;
      right: 0;
      transition: all 1s;
      -moz-transition: all 1s;	/* Firefox 4 */
      -webkit-transition: all 1s;	/* Safari 和 Chrome */
      -o-transition: all 1s;	/* Opera */
    }
    img{
      flex-grow:1;
      height: auto;
      object-fit:cover;
      z-index: 1;
      flex-shrink:1;
      width: 60%;
      transform-origin:50% 50% ;
      
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
    }
  }
  .relationAdress{
    
    display: flex;
    flex-direction: row;
    align-items: stretch;
    .relationAddressInfo:nth-of-type(2n+1){
      background: -webkit-gradient(linear, left bottom, left top, from(rgba(255, 255, 255, 0.2)), to(#F2F6FC));
      &::before{
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        z-index: 0;
        display: inline-block;
        height: 100%;
        width: 100%;
        background: -webkit-gradient(linear, left bottom, left top, from(rgba(255, 255, 255, 0.2)), to(#F2F6FC));
        
      }
    }
    .relationAddressInfo:nth-of-type(2n){
      background:-webkit-gradient(linear, left top, left bottom, from(#fff), to(#fafafa));
      &::before{
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        z-index: 0;
        display: inline-block;
        height: 100%;
        width: 100%;
        background: rgba(255, 255, 255, 0.4);
        
      }
    }
  }
  .relationAddressInfo{
    width: 100%;
    
    background: #F2F6FC;
    
    display: flex;
    flex-direction: column;
    padding: 30px;
    box-sizing: border-box;
    width: 100%;
    background: #fff;
    position: relative;
    h2{
      /*font-size: 16px;
      color: #0168b7;
      margin: 0;
      font-weight: 400;*/

      z-index: 1;
      font-size: 20px;
      position: relative;
      margin-top: 0;
      margin-bottom: 20px;
      font-weight: 400;
      color: #303133;
      &::after{
        content: '';
        display: inline-block;
        background: #0068b7;
        width: 3px;
        height: 16px;
        position: absolute;
        left: -16px;
        top: 6px;

      }
    }
    p{
      z-index: 1;
      display: inline-block;
      
      font-size: 12px;
      font-weight: 400;
      color: #80888f;
      text-align: left;
      line-height: 16px;
      transition: all 1s;
      -moz-transition: all 1s;
      -webkit-transition: all 1s;
      margin: 20px 0px !important;
      margin-bottom: 0 !important;
      margin-top: 0 !important;
      
      a{
        transition: all 1s;
        -moz-transition: all 1s;
        -webkit-transition: all 1s;
        -o-transition: all 1s;
        text-decoration: none !important;
        out-line: none !important;
        color: #80888f !important;
      }
    }
    .newAddressInfo{
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      svg{
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }
    }

  }
  .address:hover{
    
    overflow: hidden;
    img{
      transform:scale(1.4);
      -webkit-transform:scale(1.4);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:scale(1.4);     /*兼容-moz-引擎浏览器*/
    }
    .addressKP{
      width: 40%;
      background: #0168b7;
      a{
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        text-decoration:none !important;
        out-line: none !important;
        color: #fff !important;
      }

      p{
        color: #fff;
      }
      h2{
        color: #fff;
      }
    }
    .addressZZ{
      background: rgba(0,0,0,0.5);
    }
  }

  /*新的列表*/
  .newAdress{
    display: flex;
    flex-direction: row;
    height: 210px;
    width: 800px;
    margin: 0 auto;
    margin-bottom: 20px;
  }
  .newAdressImg{
    width: 280px;
    width: 0;
    overflow: hidden;
    flex-shrink:0;
    position: relative;
    img{
      display: none;
      position: absolute;
      top:0;
      left: 0;
      width: 100%;
    }
  }
  .newAdressItem{
    display: flex;
    flex-direction: column;
    padding: 20px 20px;
    padding-left: 40px;
    width: 100%;
    background: #F2F6FC;
    h2{
      font-size: 16px;
      color: #0168b7;
      margin: 0;
      transition: all 1s;
      -moz-transition: all 1s;	/* Firefox 4 */
      -webkit-transition: all 1s;	/* Safari 和 Chrome */
      -o-transition: all 1s;	/* Opera */
      font-weight: 400;
      
    }
    p{
      display: inline-block;
      
      font-size: 14px;
      font-weight: 400;
      color: #80888f;
      text-align: left;
      line-height: 20px;
      transition: all 1s;
      -moz-transition: all 1s;
      -webkit-transition: all 1s;
      margin: 20px 0px !important;
      a{
        transition: all 1s;
        -moz-transition: all 1s;
        -webkit-transition: all 1s;
        -o-transition: all 1s;
        text-decoration: none !important;
        out-line: none !important;
        color: #80888f !important;
      }
    }
    .newAddressInfo{
      display: flex;
      flex-direction: row;
      align-items: center;
      svg{
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/relation.vue